import { RECAPTCHA_SITEKEY } from 'Config/config'
import { RECAPTCHA_RESPONSE } from 'Defaults/modals'

export const generateRecaptchaToken = (action, setLoadingStatus, submit, data) => {
  if(typeof window !== 'undefined' && window.grecaptcha) {
    setLoadingStatus(true)
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(RECAPTCHA_SITEKEY, { action }).then((token) => {
        submit({
          ...data,
          [RECAPTCHA_RESPONSE]: token,
        })
        setLoadingStatus(false)
      })
    },
    )
  } else {
    // eslint-disable-next-line
    console.error('reCAPTCHA not loaded')
  }
}
